module.exports = __webpack_public_path__ + "fcc3c7d365b37eaed58129e710d90d0e.png";